module.exports = __webpack_public_path__ + "img/1.1958e4da.png";